import script from "./Tags.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tags.vue?vue&type=script&lang=ts&setup=true"

import "./Tags.vue?vue&type=style&index=0&id=48348110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48348110"]])

export default __exports__